import { render, staticRenderFns } from "./LazyImg.vue?vue&type=template&id=1a1a9a44&scoped=true"
import script from "./LazyImg.vue?vue&type=script&lang=js"
export * from "./LazyImg.vue?vue&type=script&lang=js"
import style0 from "./LazyImg.vue?vue&type=style&index=0&id=1a1a9a44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1a9a44",
  null
  
)

export default component.exports